import * as moment from 'moment';
import { OperateurExport } from './operateur-export.model';
import { StatutHabilitation } from '../../habilitation/models/statut-habilitation.model';
import { RefStatut } from '../../habilitation/models/statut.ref.model';
import { Activite } from '../../habilitation/models/activite.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class HabilitationExport {
    static jsonMap = {
        id: { key: 'id', optional: true },
        cahier: { key: 'idCahier', converter: new (DataIdConverterFactory.build(Cahier, 'cahiers'))() },
        activite: { key: 'idActivite', converter: new (DataIdConverterFactory.build(Activite, 'activites'))() },
        statut: { key: 'idStatut', converter: new (DataIdConverterFactory.build(RefStatut, 'statutsHabilitation'))(), optional: true },
        historique: { key: 'historiquesStatut', converter: new (ArrayClassConverterFactory.build(StatutHabilitation))(), optional: true, default: () => [] },
        // ajouté pour les exports
        idOperateur: { key: 'idOperateur', optional: true },
        operateur: { key: 'operateur', converter: new (ClassConverterFactory.build(OperateurExport))(), optional: true },
        datePremiereHabilitation: { key: 'datePremiereHabilitation', converter: new DateConverter(), optional: true }
    };

    public id: number;
    public cahier: Cahier;
    public activite: Activite;
    public statut: RefStatut;
    public historique: StatutHabilitation[];
    public idOperateur: number;
    public operateur: OperateurExport;
    public datePremiereHabilitation: moment.Moment;
}
